<template>
  <el-form-item :label="$t('posts.environmentTitle')">
    <el-checkbox false-label="non" true-label="oui" v-model="post.belle_vue" @change="changeCheckboxLot('belle_vue')" :checked="isChecked">
      {{ $labels.belle_vue }}
    </el-checkbox>
    <el-checkbox false-label="non" true-label="oui" v-model="post.vue_sur_mer" @change="changeCheckboxLot('vue_sur_mer')" :checked="isChecked">
      {{ $labels.vue_sur_mer }}
    </el-checkbox>
    <el-checkbox false-label="non" true-label="oui" v-model="post.est_calme" @change="changeCheckboxLot('est_calme')" :checked="isChecked">
      {{ $labels.est_calme}}
    </el-checkbox>
    <el-checkbox false-label="non" true-label="oui" v-model="post.avec_vis_a_vis" @change="changeCheckboxLot('avec_vis_a_vis')" :checked="isChecked">
      {{ $labels.avec_vis_a_vis}}
    </el-checkbox>
  </el-form-item>
</template>

<script>
export default {
  name: 'PostExterieurEnvironnement',
  props: {
    post: Object,
    changeCheckboxLot: Function,
    isChecked: [Boolean, Function]
  }
}
</script>
